export const MAX_INJECTION_COUNT = 4;

export const INJECTION_ANCHOR_QUESTION = 'treatment';

// treatment = '1' means "no injection" in the BRP survey; dosage values mean injection done.
export const INJECTION_VISIBLE_IF = `{${INJECTION_ANCHOR_QUESTION}} notempty and {${INJECTION_ANCHOR_QUESTION}} <> '1'`;

export const INJECTION_COUNT_QUESTION = 'injection_count';

export const INJECTION_PAGE_NAME = 'injection_count_page';
